<template>
  <div class="input-container">
    <input type="text" class="input-field" :class="inputClasses" :value="value"
           :placeholder="placeholder"
           @input="$emit('input', $event.target.value)"/>
    <span :class="iconClasses" v-if="withSuffix || withPrefix"><i class="fa fa-search"></i></span>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
    },
    withSuffix: {
      required: false,
      default: false,
    },
    withPrefix: {
      required: false,
      default: false,
    },
    placeholder: {
      required: false,
      type: String,
    },
  },

  computed: {
    iconClasses () {
      return {
        'input-suffix': this.withSuffix,
        'input-prefix': this.withPrefix,
      };
    },

    inputClasses () {
      return {
        'suffix-padding': this.withSuffix,
        'prefix-padding': this.withPrefix,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.input-container {
  position: relative;
}

.input-field {
  border: 1px solid #dce2ed;
  background-color: #fff;
  color: #808fa4;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  padding: 10px 10px 10px 10px;
  width: 100%;
}

.suffix-padding {
  padding: 10px 32px 10px 10px;
}

.prefix-padding {
  padding: 10px 10px 10px 32px;
}

.input-suffix {
  position: absolute;
  top: 12px;
  right: 16px;
}

.input-prefix {
  position: absolute;
  top: 12px;
  left: 16px;
}
</style>
